import {StyleSheet} from '@react-pdf/renderer'
import pTheme from '../../../themes/pTheme/pTheme'
const theme = pTheme

export const ChatExportStyles = StyleSheet.create({
  page: {
    paddingHorizontal: 30,
    paddingTop: 30,
    paddingBottom: 45,
    fontFamily: 'Open Sans',
    borderRadius: '4px'
  },
  timeStampContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 5,
    fontSize: 9,
    color: theme.palette.hpBaseDark
  },
  label: {
    marginBottom: -3.75,
    color: theme.palette.hpAccentBlack,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: 9
  },
  userLabel: {
    paddingRight: '12px',
    textAlign: 'right'
  },
  botLabel: {
    paddingLeft: '12px',
    textAlign: 'left'
  },
  userMessage: {
    backgroundColor: theme.palette.hpPrimaryLightest,
    color: theme.palette.hpAccentBlack,
    lineHeight: 1.5,
    borderRadius: '8px',
    margin: '4px 0px',
    marginBottom: '10px',
    padding: '8px 12px',
    display: 'flex',
    alignSelf: 'flex-end',
    maxWidth: '85%',
    fontSize: 9,
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap'
  },
  botMessage: {
    color: theme.palette.hpAccentBlack,
    fontSize: 9,
    lineHeight: 1.5,
    border: `1px solid ${theme.palette.hpBase}`,
    borderRadius: '8px',
    margin: '4px 0px',
    marginBottom: '10px',
    padding: '8px 12px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    maxWidth: '85%',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap'
  },
  brandingtext: {
    color: theme.palette.hpAccentBlack,
    fontSize: 9,
    lineHeight: 1.5
  },
  brandingtextHeading: {
    color: theme.palette.hpAccentBlack,
    fontSize: 9,
    fontWeight: theme.typography.fontWeightBold,
    marginTop: '2px'
  },
  chart: {
    height: 200,
    maxWidth: '100%',
    width: 'auto',
    alignSelf: 'center',
    objectFit: 'contain'
  },
  boldText: {
    fontWeight: theme.typography.fontWeightBold
  },
  aiInfoText: {
    backgroundColor: theme.palette.hpBaseLighter,
    fontSize: 7.25,
    fontStyle: 'italic',
    margin: '4px -12px -8px -12px',
    padding: '3px 10px',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    overflow: 'hidden',
    position: 'relative',
    letterSpacing: '0.2px'
  },
  styledChatExportContainer: {
    marginVertical: '10px',
    padding: '10px'
  },
  styledChatExportInsideContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    marginBottom: '8px'
  },
  betaBranding: {
    backgroundColor: theme.palette.hpAccentOrange,
    color: theme.palette.hpWhite,
    padding: '4px 8px',
    borderRadius: '10px',
    fontSize: 8,
    fontWeight: theme.typography.fontWeightBold,
    display: 'inline-block',
    textAlign: 'center',
    marginLeft: '8px',
    top: '-2px'
  },
  // Table styles for PDF export - minimal styling
  table: {
    width: '100%',
    marginTop: 8,
    marginBottom: 8
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row'
  },
  tableColHeader: {
    borderBottomWidth: 1,
    borderBottomColor: theme.palette.hpBaseLight,
    borderBottomStyle: 'solid',
    borderRightWidth: 1,
    borderRightColor: theme.palette.hpBaseLighter,
    borderRightStyle: 'solid',
    padding: 6,
    fontSize: 8,
    fontWeight: theme.typography.fontWeightSemibold
  },
  tableCol: {
    padding: 4,
    fontSize: 8,
    borderBottomWidth: 1,
    borderBottomColor: theme.palette.hpBaseLighter,
    borderBottomStyle: 'solid',
    borderRightWidth: 1,
    borderRightColor: theme.palette.hpBaseLighter,
    borderRightStyle: 'solid'
  },
  tableCellHeader: {
    fontWeight: theme.typography.fontWeightSemibold,
    fontSize: 8,
    width: '100%',
    overflow: 'hidden'
  },
  tableCell: {
    fontSize: 8,
    width: '100%',
    overflow: 'hidden'
  }
})
